<div class="text-center">
    <h3 class=" font-weight-bold text-primary">Two Factor Authentication </h3>
    <p class="text-muted">Please check your SMS for verfication code</p>
</div>
<form class="form" #twofapasswordform="ngForm" novalidate="novalidate" >
    <div class="form-group py-3">
        <mat-form-field class="example-full-width">
            <input matInput type="text" autocomplete="off"
                [(ngModel)]="twoFaValue.otp"
                placeholder="Enter OTP" 
                name="twofacode">
          </mat-form-field>
    </div>
    <div class="form-group d-flex flex-wrap flex-center">
        <button (click)="onSubmit()" class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-2">Submit</button>
        <button (click)="cancel()" class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-2">Cancel</button>
    </div>
</form>